import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    propertyDetails: {
        name: '',
    },
    previews: [],
    isLoading: true,
    error: null,
});

const boostAdPreviews = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.ANALYTICS_BOOST_AD_PREVIEWS_GET_LOADING:
            return initState();
        case DispatchConstants.ANALYTICS_BOOST_AD_PREVIEWS_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                ...payload,
            };
        case DispatchConstants.ANALYTICS_BOOST_AD_PREVIEWS_GET_FAIL:
            return {
                ...state,
                isLoading: false,
                error: payload.error,
            };

        default:
            return state;
    }
};

export default boostAdPreviews;
